import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';

import { MapElement } from '@website-builder/widgets/google-map/map-element';
import { MapStyle } from '@website-builder/widgets/google-map/model/map-style';
import { MapPosition } from '@website-builder/widgets/google-map/model/map-position';
import { MapContentStyle } from '@website-builder/widgets/google-map/model/map-content-style';
import { MapTitleStyle } from '@website-builder/widgets/google-map/model/map-title-style';
import { MapPopupStyle } from '@website-builder/widgets/google-map/model/map-popup-style';
import { BaseMultipleWidget } from '@website-builder/widgets/base/base-multiple-widget';
import { BaseWidgetNormalizer } from '@website-builder/widgets/normalizer/base-widget-normalizer';

export class GoogleMapWidget extends BaseMultipleWidget<MapElement, MapStyle> {
  readonly type = BuilderElementType.Map;
  style = new MapStyle();
  titleStyle = new MapTitleStyle();
  contentStyle = new MapContentStyle();
  popupStyle = new MapPopupStyle();
  position = new MapPosition();
  visibleMarker = 1;
  ctrlZoom = true;
  elements: MapElement[] = [];

  static normalizeInPlace(widget: GoogleMapWidget): GoogleMapWidget {
    const pureWidget = new GoogleMapWidget();

    BaseWidgetNormalizer.normalizeInPlace(widget, pureWidget);

    widget.position = widget.position ?? pureWidget.position;
    widget.visibleMarker = widget.visibleMarker ?? pureWidget.visibleMarker;
    widget.ctrlZoom = widget.ctrlZoom ?? pureWidget.ctrlZoom;
    widget.elements = (widget.elements ?? pureWidget.elements).map(element => MapElement.normalizeInPlace(element));

    widget.style = MapStyle.normalize(widget.style);
    widget.titleStyle = MapTitleStyle.normalize(widget.titleStyle);
    widget.contentStyle = MapContentStyle.normalize(widget.contentStyle);
    widget.popupStyle = MapPopupStyle.normalize(widget.popupStyle);

    return widget;
  }
}
